import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: 'ng-template[selectOptionLabel]',
  standalone: false,
})
export class MultiSelectOptionLabelDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
  selector: 'ng-template[selectSelectedLabel]',
  standalone: false,
})
export class MultiSelectSelectedLabelDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
